module.exports = __webpack_public_path__ + "img/hoslogo5.dedcfd82.png";